export default (store) => ({
  layout: { fluid: true },
  path: '/kitchens/:kitchenSlug/delivery-areas(/:deliveryAreaId)',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    import(
      /* webpackChunkName: 'DeliveryAreas' */
      './components/DeliveryAreas'
    ).then(module => {
      cb(null, module.default)
    })
  }
})